export default "__VITE_ASSET__DU0U6Ukw__"